var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"container"},[_c('survey',{attrs:{"survey":_vm.survey}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }